module.exports = __webpack_public_path__ + "static/media/site.866d53d1.webmanifest";